import type { IGroupModifierSelected, ISelectModifiers, ISizes } from "#/types/iCardProduct";

export const scrollToRequiredEmpty = () => {
	document.querySelector(`.cms_root .cms_group_required_empty, .mms_root .mms_group_required_empty`)?.scrollIntoView({ block: "nearest", behavior: "smooth" });
};

/** Подбирает размер модификатора под выбранный размер блюда. */
export const findModifierSizeForDish = (modifier: ISelectModifiers, selectedSize?: ISizes | null): ISizes | null => {
	if (!selectedSize?.id || !modifier.sizes?.length) return null;
	return modifier.sizes.find((s) => s.id === selectedSize.id) ?? null;
};

/** Проставляет size и price модификатору по размеру блюда. */
export const applySelectedSizeToModifier = (modifier: ISelectModifiers, selectedSize?: ISizes | null): ISelectModifiers => {
	const sizeForMod = findModifierSizeForDish(modifier, selectedSize);
	if (!sizeForMod) return modifier;
	return { ...modifier, size: sizeForMod, price: sizeForMod.price ?? modifier.price };
};

/** Синхронизирует все выбранные модификаторы с текущим размером блюда. */
export const applySelectedSizeToGroups = (groups: IGroupModifierSelected[], selectedSize?: ISizes | null): IGroupModifierSelected[] => {
	if (!selectedSize?.id || !groups.length) return groups;
	return groups.map((group) => ({
		...group,
		modifiers: group.modifiers.map((mod) => applySelectedSizeToModifier(mod, selectedSize)),
	}));
};

export const getModifierPriceForDishSize = (modifier: ISelectModifiers, selectedSize?: ISizes | null): number =>
	applySelectedSizeToModifier(modifier, selectedSize).price ?? modifier.price ?? 0;
